import React from "react";
import { menuItemsDocuments } from "../../utils/Data/dataTexts";
import DashboardMenu from "../UserDashboard/DashboardMenu/DashboardMenu";
import "../AdminDashboard/AdminDashboard.scss";
import ManageImportCustoms from "./ManageImportCustoms/ManageImportCustoms";
import ManageExportCustoms from "./ManageExportCustoms/ManageExportCustoms";
/* import ManageCustomsDirectRep from "./ManageCustomsDirectRep/ManageCustomsDirectRep"; */

export const DocumentsDashboardContext = React.createContext({});
export class DocumentsDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: "",
      ordersFetched: false,
      userAccountsFetched: false,
      orders: [],
      userAccounts: [],
      messages: [],
      messagesFetched: false,
    };
  }

  handleNavigation = (step) => {
    if (step !== this.state.activeStep) {
      this.setState({ activeStep: step });
    }
  };
  displayContent = (step) => {
    switch (step) {
      case "Import Customs Clearance":
        return (
          <div className="AdminDashboardContent">
            <ManageImportCustoms />
          </div>
        );
      case "Export Customs Clearance":
        return (
          <div className="AdminDashboardContent">
            <ManageExportCustoms />
          </div>
        );
      /*       case "Customs Direct Representation":
        return (
          <div className="AdminDashboardContent">
            <ManageCustomsDirectRep />
          </div>
        ); */
      default:
        return (
          <>
            <div className="AdminDashboardContent">
              <p className="WelcomeText" style={{ textAlign: "center" }}>
                Welcome! <br /> Please choose the document you want to fill out
              </p>
            </div>
          </>
        );
    }
  };

  render() {
    return (
      <DocumentsDashboardContext.Provider value={this}>
        <div className="DashboardContainer">
          <div className="DashboardMenuContainer">
            <DashboardMenu
              handleNavigation={this.handleNavigation}
              activeStep={this.state.activeStep}
              menuItems={menuItemsDocuments}
              documents
            />
          </div>
          <div className="DasboardContentContainer">
            {this.displayContent(this.state.activeStep)}
          </div>
        </div>
      </DocumentsDashboardContext.Provider>
    );
  }
}
